import React from "react";
import { ContentsProps } from "../../types";

const Customers: React.FC<ContentsProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">Loading...</div>
    );
  }

  const { total_customers, categories } = data.customers;
  const categoryColors = {
    A: "bg-blue-500",
    B: "bg-green-500",
    C: "bg-yellow-500",
  };

  return (
    <div className="p-6 space-y-6">
      {/* Total Customers Card */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-gray-800">
            Total Customers
          </h2>
          <div className="p-2 bg-blue-100 rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>
        <div className="text-3xl font-bold text-gray-900">
          {total_customers}
        </div>
        <p className="text-sm text-gray-500 mt-1">Active customer accounts</p>
      </div>

      {/* Categories Distribution */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-6">
          Customer Categories
        </h2>
        <div className="space-y-4">
          {Object.entries(categories).map(
            ([category, { count, percentage }]) => (
              <div key={category} className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium text-gray-600">
                    Category {category}
                  </span>
                  <span className="text-sm font-medium text-gray-900">
                    {count}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div
                    className={`h-2.5 rounded-full ${
                      categoryColors[category as keyof typeof categoryColors]
                    }`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            )
          )}
        </div>

        {/* Summary Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
          {Object.entries(categories).map(
            ([category, { count, percentage }]) => (
              <div
                key={category}
                className="p-4 rounded-lg bg-gray-50 border border-gray-200"
              >
                <h3 className="text-lg font-semibold mb-1">
                  Category {category}
                </h3>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">{count} </span>
                  {/* <span
                    className={`text-sm font-medium px-2 py-1 rounded-full ${
                      categoryColors[category as keyof typeof categoryColors]
                    } text-white`}
                  >
                    {percentage}%
                  </span> */}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Customers;
